import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=baae7bfc&scoped=true&"
import script from "./NewDetails.vue?vue&type=script&lang=js&"
export * from "./NewDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDetails.vue?vue&type=style&index=0&id=baae7bfc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae7bfc",
  null
  
)

export default component.exports